export default "__VITE_ASSET__HeCbwphJ__"